import axios from 'axios';
import type { GetOrgSettingsDTO } from '@bb/domain/dist/types';

const getOrgSettings = async () => {
  const { data } = await axios.get<GetOrgSettingsDTO>(`/org/settings`);

  return data;
};

export default getOrgSettings;
